(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comfort-step-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Scope to a single section instance
  var sections = document.querySelectorAll('.cs-pdp');
  sections.forEach(function (root) {
    if (root.dataset.csInit === '1') return;
    root.dataset.csInit = '1';

    var sectionId = root.dataset.sectionId;
    var jsonNode = document.querySelector('script[data-cs-product-json="' + sectionId + '"]');
    var product = null;
    try { product = JSON.parse(jsonNode.textContent); } catch (e) { product = null; }

    /* ============ GALLERY THUMBS ============ */
    var thumbs = root.querySelectorAll('.thumb');
    var galleryMain = root.querySelector('#cs-galleryMain');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var img = t.querySelector('img');
        if (img && galleryMain && galleryMain.tagName === 'IMG') {
          // Use highest-res variant for main from the same source
          var src = img.getAttribute('src');
          if (src) {
            // Replace ?width= or &width= with 1200 if present, otherwise as-is
            var newSrc = src.replace(/([?&])width=\d+/, '$1width=1200');
            galleryMain.setAttribute('src', newSrc);
            galleryMain.setAttribute('alt', img.getAttribute('alt') || '');
          }
        }
      });
    });

    /* ============ VARIANT OPTIONS ============ */
    var variantIdInput = root.querySelector('#cs-variantId');
    var priceActive = root.querySelector('#cs-priceActive');
    var priceCompare = root.querySelector('#cs-priceCompare');
    var saleBadge = root.querySelector('#cs-saleBadge');
    var addToCart = root.querySelector('#cs-addToCart');
    var addToCartPrice = root.querySelector('#cs-addToCartPrice');
    var buyNow = root.querySelector('#cs-buyNow');

    function getCurrentSelection() {
      var optionGroups = root.querySelectorAll('.option-group[data-option-position]');
      var selected = [];
      optionGroups.forEach(function (g) {
        var pressed = g.querySelector('[aria-pressed="true"]');
        if (pressed) selected.push(pressed.getAttribute('data-option-value'));
      });
      return selected;
    }

    function findVariant(selectedOptions) {
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      // Light fallback formatting; use shop currency if present
      var amount = (cents / 100).toFixed(2);
      var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? '' : '$';
      return symbol + amount;
    }

    function updateUI() {
      var sel = getCurrentSelection();
      var variant = findVariant(sel);

      // Update displayed option labels
      root.querySelectorAll('.option-group[data-option-position]').forEach(function (g) {
        var pos = g.getAttribute('data-option-position');
        var pressed = g.querySelector('[aria-pressed="true"]');
        var display = g.querySelector('[data-option-display="' + pos + '"]');
        if (pressed && display) display.textContent = pressed.getAttribute('data-option-value');
      });

      if (!variant) {
        if (addToCart) {
          addToCart.disabled = true;
          var t = root.querySelector('#cs-addToCartText');
          if (t) t.textContent = 'UNAVAILABLE';
        }
        if (buyNow) buyNow.disabled = true;
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceActive) priceActive.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.removeAttribute('hidden');
          if (saleBadge) {
            var disc = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            saleBadge.textContent = disc + '% OFF';
            saleBadge.style.display = '';
          }
        } else {
          priceCompare.setAttribute('hidden', '');
          if (saleBadge) saleBadge.style.display = 'none';
        }
      }

      if (addToCart) {
        addToCart.disabled = !variant.available;
        var t = root.querySelector('#cs-addToCartText');
        if (t) {
          if (variant.available) {
            t.innerHTML = 'ADD TO CART — <span id="cs-addToCartPrice">' + formatMoney(variant.price) + '</span>';
          } else {
            t.textContent = 'SOLD OUT';
          }
        }
      }
      if (buyNow) buyNow.disabled = !variant.available;

      // Swap main image to variant featured image, if any
      if (variant.featured_image && variant.featured_image.src && galleryMain && galleryMain.tagName === 'IMG') {
        var src = variant.featured_image.src;
        // Ensure HTTPS and a reasonable width
        if (src.indexOf('//') === 0) src = 'https:' + src;
        // Add width param if Shopify CDN
        if (src.indexOf('cdn.shopify.com') > -1 && src.indexOf('width=') === -1) {
          src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        }
        galleryMain.setAttribute('src', src);
      }
    }

    // Wire up swatches and pills
    root.querySelectorAll('[data-option-position][data-option-value]').forEach(function (el) {
      el.addEventListener('click', function () {
        var pos = el.getAttribute('data-option-position');
        // Unselect siblings within the same option-group
        var group = el.closest('.option-group');
        if (!group) return;
        group.querySelectorAll('[data-option-value]').forEach(function (sib) {
          sib.setAttribute('aria-pressed', 'false');
          sib.setAttribute('aria-checked', 'false');
        });
        el.setAttribute('aria-pressed', 'true');
        el.setAttribute('aria-checked', 'true');
        updateUI();
      });
    });

    /* ============ QUANTITY ============ */
    var qtyInput = root.querySelector('#cs-qtyInput');
    var qtyMinus = root.querySelector('#cs-qtyMinus');
    var qtyPlus = root.querySelector('#cs-qtyPlus');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1 || 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) + 1 || 1);
    });

    /* ============ PAIN POINT TABS ============ */
    var tabBtns = root.querySelectorAll('.tab-btn');
    var tabPanels = root.querySelectorAll('.tab-panel');
    tabBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        tabBtns.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        tabPanels.forEach(function (p) { p.setAttribute('aria-hidden', 'true'); });
        b.setAttribute('aria-selected', 'true');
        var id = b.getAttribute('data-tab');
        var panel = root.querySelector('.tab-panel[data-tab="' + id + '"]');
        if (panel) panel.setAttribute('aria-hidden', 'false');
      });
    });

    /* ============ ADD-TO-CART (AJAX with toast) ============ */
    var form = root.querySelector('#cs-product-form');
    var toast = root.querySelector('#cs-toast');
    var toastTimer;

    function showToast() {
      if (!toast) return;
      toast.classList.add('is-shown');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-shown'); }, 3500);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addToCart) addToCart.disabled = true;
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            // Surface server error
            var msg = (res.data && res.data.description) || 'Could not add to cart';
            alert(msg);
            return;
          }
          showToast();
          // Refresh cart drawer / count if the parent theme listens for these
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: res.data }));
        })
        .catch(function () { alert('Network error. Please try again.'); })
        .finally(function () {
          if (addToCart) addToCart.disabled = false;
        });
      });
    }

    /* ============ BUY IT NOW (Shopify dynamic checkout) ============ */
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        var variantId = variantIdInput ? variantIdInput.value : null;
        var qty = qtyInput ? qtyInput.value : 1;
        if (variantId) window.location.href = '/cart/' + variantId + ':' + qty;
      });
    }

    // Initial sync
    updateUI();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
